import tinycolor from "tinycolor2";
import { Link } from "react-router-dom";
import { useTheme } from "../Theming/ThemingProvider";
import "./HpButton.css";
import { clampBright } from "../../lib/colorUtils";

export const HpButton = ({
  onClick,
  children,
  outlined = false,
  soft = false,
  ghost = false,
  primaryColor,
  className = "",
  to,
  size,
  fullWidth = false,
  disabled = false,
  active = false,
  squared = false,
  iconOnly = false,
  ...rest
}) => {
  const { theme } = useTheme();

  const primary = primaryColor || theme.primaryColor;
  const secondary = primaryColor
    ? clampBright(tinycolor(primaryColor), 80, 240)
    : theme.secondaryColor;

  const tc = tinycolor(primary);
  const textOnPrimary = tc.isLight() ? "#111111" : "#ffffff";
  const hoverPrimary = tc.clone().darken(12).toHexString();
  const disabledPrimary = tc.clone().lighten(22).toHexString();

  const hoverSecondary = tinycolor(secondary).darken(8).toHexString();
  const disabledSecondary = tinycolor(secondary).lighten(10).toHexString();
  const disabledSoftText = tc.clone().lighten(28).toHexString();

  const cssVars = outlined
    ? {
        "--btn-bg": "transparent",
        "--btn-text": primary,
        "--btn-border": primary,
        "--btn-hover-bg": secondary,
        "--btn-hover-text": primary,
        "--btn-hover-border": primary,
        "--btn-disabled-bg": secondary,
        "--btn-disabled-text": disabledPrimary,
        "--btn-disabled-border": disabledPrimary,
      }
    : soft
      ? {
          "--btn-bg": secondary,
          "--btn-text": primary,
          "--btn-border": secondary,
          "--btn-hover-bg": hoverSecondary,
          "--btn-hover-text": primary,
          "--btn-hover-border": hoverSecondary,
          "--btn-disabled-bg": disabledSecondary,
          "--btn-disabled-text": disabledSoftText,
          "--btn-disabled-border": disabledSecondary,
        }
      : ghost
        ? {
            "--btn-bg": "transparent",
            "--btn-text": primary,
            "--btn-border": "transparent",
            "--btn-hover-bg": secondary,
            "--btn-hover-text": primary,
            "--btn-hover-border": "transparent",
            "--btn-disabled-bg": "transparent",
            "--btn-disabled-text": disabledPrimary,
            "--btn-disabled-border": "transparent",
          }
        : {
            "--btn-bg": primary,
            "--btn-text": textOnPrimary,
            "--btn-border": primary,
            "--btn-hover-bg": hoverPrimary,
            "--btn-hover-text": textOnPrimary,
            "--btn-hover-border": hoverPrimary,
            "--btn-disabled-bg": secondary,
            "--btn-disabled-text": primary,
            "--btn-disabled-border": secondary,
          };

  const classes = [
    "hp-button",
    outlined && "hp-button--outlined",
    size === "sm" && "hp-button--sm",
    size === "lg" && "hp-button--lg",
    fullWidth && "hp-button--full-width",
    active && !disabled && "hp-button--active",
    disabled && "hp-button--disabled",
    iconOnly && "hp-button--icon",
    squared && "hp-button--squared",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  const Tag = to ? Link : "button";

  return (
    <Tag
      {...(to ? { to } : {})}
      className={classes}
      style={cssVars}
      onClick={!disabled ? onClick : undefined}
      disabled={!to && disabled}
      {...rest}
    >
      {children}
    </Tag>
  );
};
